import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../common/Loading';
import RegisterForm from '../authentication/RegisterForm';
import AuthSplitLayout from '../../layouts/AuthSplitLayout';
import Flex from '../common/Flex';
import { Link } from 'react-router-dom';
import bgImg from '../../assets/img/generic/4.jpg';

const RegisterPage = () => {
  const { authenticated, loading } = useAuth();

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return <Loading fullscreen message="Verificando autenticación..." />;
  }

  // Redirigir al dashboard si ya está autenticado
  if (authenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthSplitLayout bgProps={{ 
      image: bgImg, 
      position: '50% 20%',
      overlay: true 
    }}>
      <Flex alignItems="center" justifyContent="between" className="mb-3">
        <h3 className="mb-0">Crear Cuenta</h3>
        <p className="mb-0 fs-10">
          <span className="fw-semibold">¿Ya tienes cuenta? </span>
          <Link to="/login" className="text-decoration-none">
            Iniciar Sesión
          </Link>
        </p>
      </Flex>
      
      <RegisterForm hasLabel />
    </AuthSplitLayout>
  );
};

export default RegisterPage; 